import Select, { ActionMeta } from 'react-select';

import CheckmateSelectHelper from '../../utilities/CheckmateSelectHelper';
import { IMultiSelectOption } from '../../interfaces/ILookup';
import { IQueryFilterCriteriaSelectionValue } from '../../interfaces/IQuery';
import { RefObject } from 'react';

function CheckmateSelect(props: {
    autoFocus?: boolean;
    isDisabled?: boolean;
    isLoading?: boolean;
    isMulti?: boolean;
    name?: string;
    notClearable?: boolean;
    onChange: (optionsList: any, actionMeta?: ActionMeta<any>) => void;
    onPreventRemoveValue?: (removedValue: IMultiSelectOption) => void;
    options: IMultiSelectOption[] | IQueryFilterCriteriaSelectionValue[];
    placeholder?: string;
    selectRef?: RefObject<any>;
    systemPopulated?: boolean;
    tabIndex?: number;
    value?: IMultiSelectOption | IMultiSelectOption[] | IQueryFilterCriteriaSelectionValue[];
}) {
    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            borderRadius: 0,
            height: props.isMulti ? null : 34.4,
            minHeight: 34.4,
            borderColor: 'var(--gray-color)',
            boxShadow: 'none',
            '&:hover, &:focus-within': {
                border: 'solid 1px var(--blue-color)',
                boxShadow: '0 0 0 1px var(--blue-color)',
            },
        }),
        valueContainer: (provided: any) => ({
            ...provided,
            height: props.isMulti ? null : 34.4,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        input: (provided: any) => ({
            ...provided,
            margin: 0,
            height: props.isMulti ? null : 34.4,
        }),
        indicatorsContainer: (provided: any) => ({
            ...provided,
            height: props.isMulti ? null : 34.4,
        }),
        placeholder: (provided: any) => ({
            ...provided,
            color: '#C7C8CA',
        }),
        singleValue: (provided: any) => ({
            ...provided,
            color: props.systemPopulated ? '#4ABDAC' : 'black',
        }),
        multiValueLabel: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: '#ffffff',
            fontSize: '100%',
            fontWeight: state.data.isFixed ? 'bold' : 'inherit',
        }),
        multiValueRemove: (base: any, state: any) => {
            return state.data.isFixed ? { ...base, display: 'none' } : base;
        },
        option: CheckmateSelectHelper.getSelectOptionStyles,
    };

    const handleChange = (newValue: any, actionMeta?: ActionMeta<any>) => {
        switch (actionMeta?.action) {
            case 'deselect-option':
                if (
                    actionMeta.option?.isFixed ||
                    actionMeta.option?.readOnly ||
                    actionMeta.option?.preventRemoval
                ) {
                    props.onPreventRemoveValue?.(actionMeta.option);
                    return;
                }
                break;
            case 'remove-value':
            case 'pop-value':
                if (
                    actionMeta.removedValue?.isFixed ||
                    actionMeta.removedValue?.preventRemoval
                ) {
                    props.onPreventRemoveValue?.(actionMeta.removedValue);
                    return;
                }
                break;
            case 'clear':
                if (Array.isArray(props.value)) {
                    newValue = props.value
                        ?.filter((v) => v !== undefined && v !== null)
                        .filter((v) => v.isFixed);
                }
                break;
        }

        props.onChange(newValue, actionMeta);
    };

    return (
        <div style={{ minWidth: '125px' }}>
            <Select
                autoFocus={props.autoFocus ?? false}
                closeMenuOnSelect={props.isMulti ? false : true}
                hideSelectedOptions={false}
                isClearable={!props.notClearable}
                isDisabled={props.isDisabled}
                isLoading={props.isLoading}
                isMulti={props.isMulti}
                loadingMessage={() => 'Loading...'}
                onChange={handleChange}
                options={props.options.filter((opt) => !opt.isFixed)}
                placeholder={props.placeholder || '-- Select --'}
                ref={props.selectRef}
                styles={customStyles}
                tabIndex={props.tabIndex}
                value={props.value ?? null}
            />
        </div>
    );
}

export default CheckmateSelect;
